<template>
  <div>
    <main class="mt-3 member-list">

      <div v-if="isLoading" class="loading-indicator">
        <span class="spinner"></span>
        회원리스트 로딩...
      </div>

      <div class="pl-1 text-center">
        <div class="alert alert-success" role="alert">
          <b class="fs-4">회 원 리 스 트</b>
          <p class="mb-0">총원( <b>{{ getCurrencyFormat(totMem) }}</b> ) / 멤버십( <b>{{ getCurrencyFormat(cntMem) }}</b> )</p>
        </div>

        <div class="d-flex justify-content-between align-items-center flex-wrap mb-2 gy-2">
          <select class="form-select form-select-sm" style="width:auto;" v-model="rProcCode" @change="changeProcCode(rProcCode)">
            <option :value="noVal" disabled>회원분류</option>
            <option value="A">전체보기</option>
            <option value="App" style="color:red;">앱설치</option>
            <option value="Mem" style="color:darkgreen;">멤버십</option>
            <option value="N">네이버경유</option>
            <option value="K">카카오경유</option>
            <option value="E">홈페이지경유</option>
            <option value="H">수동등록</option>
          </select>

          <div class="d-flex flex-wrap" style="gap:8px;">
            <button type="button" class="btn btn-primary btn-sm" @click="showRegistMember">회원등록</button>
            <button type="button" class="btn btn-outline-success btn-sm" @click="exportToCSV">App회원다운로드(CSV)</button>
            <button type="button" class="btn btn-outline-dark btn-sm" @click="exportCheckedToCSV">체크회원다운로드(CSV)</button>
            <button type="button" class="btn btn-outline-info btn-sm" :disabled="isLoading" @click="refreshMemberList" title="포인트/멤버십 등 최신 상태로 다시 불러옵니다">
              <i class="bi bi-arrow-clockwise"></i> 새로고침
            </button>
          </div>
        </div>

        <!-- register area -->
        <table class="table table-bordered table-striped fs-6" v-if="createFlag === 'Y'">
          <thead class="small">
            <tr>
              <th style="width:10%;">아이디</th>
              <th style="width:10%;">성명</th>
              <th style="width:5%;">가입경로</th>
              <th style="width:8%;">기본연락처</th>
              <th style="width:10%;">카카오톡연락처</th>
              <th style="width:5%;">생일</th>
              <th style="width:3%;">성별</th>
              <th style="width:12%;">비고사항</th>
              <th style="width:5%;">등록</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr>
              <td><input type="text" class="form-control form-control-sm" v-model="uEmail" maxlength="40" ref="uEmail"></td>
              <td><input type="text" class="form-control form-control-sm" v-model="uNickName" maxlength="40" ref="uNickName"></td>
              <td>수동(H)</td>
              <td><input type="text" class="form-control form-control-sm" v-model="uPhone" maxlength="15" ref="uPhone"></td>
              <td><input type="text" class="form-control form-control-sm" v-model="alimCallC" maxlength="15" ref="alimCallC"></td>
              <td>
                <input type="text" class="form-control form-control-sm mb-1" v-model="uBirthyear" maxlength="4" ref="uBirthyear" placeholder="연도만">
                <input type="text" class="form-control form-control-sm" v-model="uBirthday" maxlength="4" ref="uBirthday" placeholder="월일만">
              </td>
              <td>
                <select class="form-select form-select-sm" ref="uGender" v-model="uGender">
                  <option value="male" selected>남성</option>
                  <option value="female">여성</option>
                </select>
              </td>
              <td>
                <textarea class="form-control form-control-sm" placeholder="100자 이내" ref="spRemarks" style="height:40px;" v-model="spRemarks" maxlength="100"></textarea>
              </td>
              <td>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="registMember">OK</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="mt-2 mb-2 align-middle fs-4">
          <i class="bi bi-arrow-down-square-fill text-secondary" v-if="createFlag === 'Y'"></i>
        </div>

        <!-- 회원리스트 -->
        <div class="member-table-wrap">
          <table class="table table-striped table-hover align-middle member-table">
            <thead>
              <tr>
                <th style="width:40px;">
                  <input type="checkbox" v-model="allSelected" @change="allChoice()" title="현재 필터된 전체 회원을 대상으로 선택됩니다" />
                </th>
                <th style="width:5%;">멤버십</th>
                <th style="width:4%;">번호</th>
                <th style="width:4%;">APP설치</th>
                <th style="width:7%;">아이디</th>
                <th style="width:7%;">성명</th>
                <th style="width:5%;">경로</th>
                <th style="width:7%;">가입일</th>
                <th style="width:8%;">연락처/알림톡</th>
                <th style="width:8%;">여권정보</th>
                <th style="width:5%;">생일</th>
                <th style="width:5%;">성별</th>
                <th style="width:6%;">직가입비번</th>
                <th style="width:5%;">포인트</th>
                <th style="width:10%;">비고사항</th>
                <th style="width:8%;">기능</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="pagedMemberInfo.length === 0">
                <td colspan="16" class="text-center text-muted py-4">표시할 회원이 없습니다.</td>
              </tr>
              <tr :key="m.uEmail" v-for="(m, i) in pagedMemberInfo">
                <td>
                  <input type="checkbox" v-model="m.checkFlag" :id="'chk_' + m.uEmail" name="checkedBox"><br>
                  {{ (currentPage - 1) * pageSize + i + 1 }}
                </td>

                <td v-if="m.memLevel === 'N'">
                  <span class="text-success fw-bold">Y</span>
                  <br>
                  <small class="text-muted">{{ m.insMember_fmt }}<br>{{ m.expMember_fmt }}</small>
                </td>
                <td v-else></td>

                <td v-if="m.memLevel === 'N'">{{ m.memNo }}</td>
                <td v-else></td>

                <td style="font-weight:600; color:red;">{{ m.instApp }}</td>

                <td>
                  {{ m.uEmail }}
                  <p style="color:cornflowerblue;">({{"M-" + m.joinSeq }})</p>
                </td>

                <td v-if="m.joinFlag == 'E' || m.joinFlag == 'H'">
                  <input type="text" class="form-control form-control-sm" v-model="m.uNickName">
                </td>
                <td v-else>{{ m.uNickName }}</td>

                <td>{{ m.joinRoute }}</td>

                <td v-if="m.insDate == undefined">미확인</td>
                <td v-else class="text-secondary">{{ m.insDate_fmt }}</td>

                <td>
                  <input type="text" class="form-control form-control-sm mb-1" v-model="m.uPhone">
                  <input type="text" class="form-control form-control-sm" v-model="m.alimCallC">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm mb-1" v-model="m.uPassport" placeholder="여권번호">
                  <input type="date" class="form-control form-control-sm mb-1" v-model="m.passExpDate">
                  <input type="text" class="form-control form-control-sm" v-model="m.engName" placeholder="영문명(여권상 성명)">
                </td>

                <td>
                  <input type="text" class="form-control form-control-sm mb-1" v-model="m.uBirthyear">
                  <input type="text" class="form-control form-control-sm" v-model="m.uBirthday" :readonly="m.joinFlag === 'K' || m.joinFlag === 'N'">
                </td>

                <td>
                  <select class="form-select form-select-sm" v-model="m.uGender">
                    <option value="male">남성</option>
                    <option value="female">여성</option>
                  </select>
                </td>

                <td v-if="m.uPass === undefined">-</td>
                <td v-else>{{ m.uPass }}</td>

                <td class="text-primary">
                  <a @click="goToPoint(m.uEmail)" style="cursor:pointer;">{{ m.point_fmt }}</a>
                </td>

                <td>
                  <textarea class="form-control form-control-sm" v-model="m.spRemarks" maxlength="100" style="min-height:50px;"></textarea>
                </td>

                <td>
                  <div class="d-grid" style="gap:4px;">
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="changeStatus(m.uBirthday, m.uNickName, m.alimCallC, m.uPhone, m.uGender, m.uEmail, m.spRemarks, m.uBirthyear, m.engName)">변경</button>
                    <button type="button" class="btn btn-outline-danger btn-sm" @click="memWithdrawal(m.uEmail)">탈퇴</button>
                    <button type="button" class="btn btn-outline-success btn-sm" @click="addMem(m.uEmail, m.uNickName, m.alimCallC, m.memLevel)">멤버가입</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 페이징 컨트롤 -->
        <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
          <div>
            <select class="form-select form-select-sm d-inline-block" style="width:auto;" v-model.number="pageSize" @change="changePageSize">
              <option :value="30">30개씩</option>
              <option :value="50">50개씩</option>
              <option :value="100">100개씩</option>
              <option :value="200">200개씩</option>
            </select>
            <span class="ms-2 text-secondary small">전체 {{ memberInfo.length }}건</span>
          </div>
          <div>
            <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">이전</button>
            <span class="mx-2">{{ currentPage }} / {{ totalPages }}</span>
            <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">다음</button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions'
import moment from 'moment';
import {generateCouponCode_mem} from '../assets/js/genCode'

export default {
  data() {
    return {
      isLoading: false,         // 로딩중 여부

      memberInfo: [],           //회원정보(필터 적용된 전체 리스트)
      allSelected: "N",         //전체체크여부

      //회원등록정보
      uEmail: "",
      uNickName: "",
      uPhone: "",
      alimCallC: "",
      uBirthday: "",
      uGender: "",
      spRemarks: "",

      //회원등록란 표시플래그
      createFlag: "N",
      totMem: 0,              //회원총수
      totPre: 0,              //프리미엄총수
      totStd: 0,              //스탠다드총수
      memberInfo_org: [],     //조건별 소팅용 원형리스트

      cntMem: 0,              //신멤버십 회원수(테스트멤버제외)

      memCpInfo: [],          //멤버십 전용할인기본정보

      // 상단 검색select 관련 - data()에 선언이 누락되어 있던 부분 (반응형 미확보 버그) 수정
      rProcCode: "A",          // 기본값을 'A'(전체보기)로 하여 최초 표시데이터와 일치시킴
      noVal: "",                // 비활성 placeholder 옵션용

      // 클라이언트 페이징
      currentPage: 1,
      pageSize: 50,
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.getMemberList();

    this.getHandlerInfo()                               //알림톡 발송대상 체크
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    // 전체 페이지 수
    totalPages() {
      return Math.max(1, Math.ceil(this.memberInfo.length / this.pageSize));
    },
    // 현재 페이지에 해당하는 회원만 잘라서 렌더 (핵심 성능개선 포인트)
    pagedMemberInfo() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.memberInfo.slice(start, start + this.pageSize);
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    document.getElementById("user").style.display = "none";
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    //로딩인디케이터
    showLoading() {
      this.$loading.start()
      setTimeout(() => {
        this.$loading.finish()
      }, 3000)
    },

    exportCheckedToCSV() {
      // 체크된 회원만 필터링 (페이징과 무관하게 필터된 전체 memberInfo 기준)
      const checkedMembers = this.memberInfo.filter(item => item.checkFlag === true);

      if (!checkedMembers.length) {
        this.$swal.fire("", "다운로드할 체크된 회원이 없습니다.", "warning");
        return;
      }

      const headers = [ "userId" ];
      const rows = checkedMembers.map(item => [ `${item.uEmail}` ]);

      let csvContent = headers.join(',') + '\n' + rows.map(r => r.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "체크회원리스트.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    exportToCSV() {
      let appMember = this.memberInfo.filter(item => {
        return (item.instApp =='Y' && item.testFlag != 'Y')
      })

      if (!appMember || appMember.length === 0)
      {
        this.$swal.fire("", "다운로드할 앱회원 데이터가 없습니다.", "warning");
        return;
      }

      const headers = [ "userId" ];
      const rows = appMember.map(item => [ `${item.uEmail}` ]);

      let csvContent = headers.join(',') + '\n' + rows.map(r => r.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "회원리스트.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    //회원정보리스트
    async getMemberList() {
      this.isLoading = true;
      this.$loading.start();

      let memberInfo = await this.$api("/api/memberInfo", {});

      if(memberInfo.length > 0)
      {
        // row 렌더마다 함수를 호출하지 않도록, 표시용 필드를 fetch 시점에 한 번만 계산
        // + checkFlag를 최초부터 명시적으로 선언(Vue2 반응성 확보)
        memberInfo = memberInfo.map(item => ({
          ...item,
          checkFlag: false,
          insDate_fmt: item.insDate ? this.getDateFormat(item.insDate) : '미확인',
          insMember_fmt: item.insMember ? this.getDateFormat(item.insMember) : '',
          expMember_fmt: item.expMember ? this.getDateFormat(item.expMember) : '',
          point_fmt: this.getCurrencyFormat(item.point),
        }));

        this.memberInfo_org = memberInfo           //for 조건별 소팅

        this.memberInfo = memberInfo
        this.totMem = memberInfo.length
        this.currentPage = 1              // 새로 불러오면 1페이지부터

        // 멤버십 회원수
        this.cntMem = memberInfo.reduce((cnt, item) => cnt + (item.memLevel === 'N' ? 1 : 0),0)
      }

      this.isLoading = false;
      this.$loading.finish();       //인디케이터 중지
    },

    // 포인트/멤버십처럼 리스트를 띄워놓은 사이에도 변동되는 값을 수동으로 최신화
    // location.reload()가 아니라 데이터만 다시 받아오므로 화면 유지가 빠름
    // 단, 데이터가 바뀌었으므로 1페이지로 리셋되고 체크했던 항목도 초기화됨(의도된 동작)
    async refreshMemberList() {
      await this.getMemberList();

      // 필터가 걸려있던 상태였다면 새로고침 후에도 그대로 유지
      if(this.rProcCode && this.rProcCode !== this.noVal && this.rProcCode !== 'A')
      {
        this.changeProcCode(this.rProcCode);
      }
    },

    //검색조건변경
    changeProcCode(param) {
      this.currentPage = 1        // 필터 바뀌면 1페이지로 리셋

      if(param === 'A')
      {
        // 서버 재조회 대신 이미 가져온 원본 리스트를 그대로 사용 -> 선택 즉시 반영
        this.memberInfo = this.memberInfo_org.slice()
      }
      else if(param === "App")
      {
        this.memberInfo = this.memberInfo_org.filter(item => {
          return (item.instApp =='Y')
        })
      }
      else if(param === "Mem")
      {
        this.memberInfo = this.memberInfo_org.filter(item => {
          return (item.memLevel === 'N')
        })
      }
      else
      {
        this.memberInfo = this.memberInfo_org.filter(item => {
          return (item.joinFlag === param)
        })
      }
    },

    // 페이지 이동
    goToPage(page) {
      if(page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    // 페이지 크기 변경 시 1페이지로 리셋
    changePageSize() {
      this.currentPage = 1;
    },

    allChoice()
    {
      // 주의: 현재 필터된 전체(memberInfo) 대상, 화면에 보이는 페이지만이 아님
      if(this.allSelected)
      {
        this.memberInfo.forEach((uNickName) => {
          uNickName.checkFlag = true;
        })
      }
      else
      {
        this.memberInfo.forEach((uNickName) => {
          uNickName.checkFlag = false;
        })
      }
    },
    //회원정보수정
    changeStatus(uBirthday, uNickName, alimCallC, uPhone, uGender, uEmail, spRemarks, uBirthyear, uEngName)
    {
      this.$swal.fire({
        title: '회원정보를 변경합니까?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let upd_memberInfo = await this.$api("/api/upd_memberInfo", {param: [
            uBirthday, uNickName, alimCallC, uPhone, uGender, spRemarks, uBirthyear, uEngName, uEmail
          ]});
          if(upd_memberInfo.affectedRows > 0)
          {
            this.$swal.fire('', '변경완료', 'success')
            location.reload();
          }
          else
          {
            this.$swal.fire('', '오류가 발생했습니다(코드:upd_memberInfo)', 'warning')
            return false;
          }
        }
      })
    },

    async getMemberCouponInfo() {
      let memCpInfo = await this.$api("/api/memberCouponInfo", {param: [ 'MDC', 'Y' ] })

      if(memCpInfo.length > 0)
      {
        this.memCpInfo = memCpInfo
      }
    },

    async genCpCode_mem(param) {
      let cpCode = ""

      if(param === "monthly") cpCode = "M"
      else if(param === "new") cpCode = "N"

      return await generateCouponCode_mem(this.$api, cpCode);
    },

    //멤버십가입 수동처리
    async addMem(uEmail, uNickName, alimCallC, memLevel){
      let in_engName      = ""      //여권상영문명
      let in_uPassport    = ""      //여권번호
      let in_uPassportExp = ""      //여권만료일

      if(memLevel === "N")
      {
        this.$swal.fire("","이미 멤버십에 가입한 회원입니다.","info")
        return false
      }
      const result = await this.$swal.fire({
        title: "[여 권 정 보]",
        html: `
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <p>
              <input type="text" id="engName" class="swal2-input" placeholder="여권상영문명">
            </p>
            <p>
              <input type="text" id="passNo" class="swal2-input" placeholder="여권번호">
            </p>
            <p style="margin: 0;" class="text-center">
              <b>여권만료일</b> <input type="date" id="passExp" class="swal2-input" style="margin:5; padding:5; width: 230px;"  placeholder="여권만료일">
            </p>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "가입처리",
        denyButtonText: "취소"
      })

      if(!result.isConfirmed)
      {
        return false;
      }

      in_engName      = document.getElementById("engName").value
      in_uPassport    = document.getElementById("passNo").value
      in_uPassportExp = document.getElementById("passExp").value

      if(in_engName == undefined || in_uPassport == undefined || in_uPassportExp == undefined)
      {
        this.$swal.fire("","여권정보를 모두 입력해 주세요.","warning")
        return false;
      }

      let insId_h = this.user.handlerId
      let in_memLevel = "N"

      this.getMemberCouponInfo()

      let mShipFlag = "Y"
      let mUseFlag = "Y"
      let today = new Date();
      let yyyy = today.getFullYear()
      let mm_tmp = today.getMonth()+1
      let dd_tmp = today.getDate();

      let mm = "";
      if(mm_tmp < 10) {mm = "0" + mm_tmp}
      else mm = mm_tmp;

      let dd = "";
      if(dd_tmp < 10) {dd = "0" + dd_tmp}
      else dd = dd_tmp;

      let payDate = yyyy +"-" + mm + "-" + dd

      let oneYearLater_tmp
      let oneYearLater
      let paidFlag = "Y"

      oneYearLater_tmp = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
      let oneYearLater_tmptmp = oneYearLater_tmp.setDate(oneYearLater_tmp.getDate() - 1);
      oneYearLater = moment(oneYearLater_tmptmp).format('YYYY-MM-DD HH:mm:ss');

      try
      {
        let res_joinMembership = await this.$api("/api/proc_joinMembership_new", {param: [
          mShipFlag, uEmail,
          in_engName, in_uPassport, this.getDateFormat(in_uPassportExp), in_memLevel, oneYearLater, mUseFlag, paidFlag, alimCallC, insId_h
        ]})

        if (res_joinMembership.error)
        {
          this.$swal.fire(
            "에러 발생",
            "멤버십 가입 진행 중 오류가 발생했습니다: " + res_joinMembership.error.sqlmessage,
            "error"
          );

          console.error("프로시저 호출 에러:", res_joinMembership.error);
          return false;
        }

        else
        {
          let memCpName_A   = this.memCpInfo.find(e => e.procCode === 'A').procName;
          let memCpName_B   = this.memCpInfo.find(e => e.procCode === 'B').procName;

          let memCpDcPrc_A  = this.memCpInfo.find(e => e.procCode === 'A').col_int1;
          let memCpDcType_A = this.memCpInfo.find(e => e.procCode === 'A').col_char1;

          let memCpDcPrc_B  = this.memCpInfo.find(e => e.procCode === 'B').col_int1;
          let memCpDcType_B = this.memCpInfo.find(e => e.procCode === 'B').col_char1;

          let cpUseFlag = "N"
          let validFlag = "Y"

          let cpIssueQty_A = 12
          let cpIssueQty_B = 1

          let cpCat_A = "L"
          let cpCat_B = "NN"

          let cpType_A = "monthly"
          let cpType_B = "new"

          let memCpType_A = "A"
          let memCpType_B = "B"

          let cpUseCode = "CA"
          let cpWithPoint = "N"

          let cpCode_monthly = await this.genCpCode_mem("monthly")
          let cpCode_new = await this.genCpCode_mem("new")

          let cpMonthlyDC = await this.$api("/api/proc_createMemCoupon_new_new", {param: [
            cpType_A, uEmail, cpCode_monthly, memCpName_A, oneYearLater, cpUseFlag, memCpDcPrc_A, memCpDcType_A, memCpType_A, validFlag,
            cpType_A, cpIssueQty_A, cpUseCode, cpCat_A, alimCallC, cpWithPoint
          ]})

          if(cpMonthlyDC.out_success === "0")
          {
            this.$swal.fire("", "멤버십 전용 월할인 쿠폰 생성에 문제가 발생했습니다.<br>고객센타(1660-4602)로 문의해 주세요", "warning")
            return false;
          }
          else
          {
            let cpNewDC = await this.$api("/api/proc_createMemCoupon_new_new", {param: [
              cpType_B, uEmail, cpCode_new, memCpName_B, oneYearLater, cpUseFlag, memCpDcPrc_B, memCpDcType_B, memCpType_B, validFlag,
              cpType_B, cpIssueQty_B, cpUseCode, cpCat_B, alimCallC, cpWithPoint
            ]})
            if(cpNewDC.out_success === "0")
            {
              this.$swal.fire("", "멤버십 전용 신규상품 할인쿠폰 생성에 문제가 발생했습니다.<br>고객센타(1660-4602)로 문의해 주세요", "warning")
              return false;
            }
            else
            {
              this.$swal.fire("", "멤버십 수동가입 완료.<br>카카오알림톡을 발송.", "info").then(() => {
                this.sendKakao("MJO", payDate, oneYearLater, in_memLevel, uEmail, alimCallC, uNickName)
              })
            }
          }
        }
      }
      catch(error)
      {
        console.error("프로시저 호출 에러:", error);
        return false;
      }
    },

    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    /** 멤버십가입 카카오알림 발송 */
    async sendKakao(param, payDate, expDate, in_memLevel, uEmail, alimCallC, uNickName)
    {
      if(alimCallC.charAt(0) === "+")
      {
        alimCallC = alimCallC.replace("+82 ", "0")
      }
      alimCallC = alimCallC.replace(/-/g,"")

      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        uEmail, param, alimCallC
      ]});

      this.handTel.push({aimCall: alimCallC})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0)
      {
        let promises = []

        let membership = ""
        let mPayAmt = 0
        if(in_memLevel === "N")
        {
          membership = "엔데이트립 멤버십"
          mPayAmt = "2,900"
        }

        let i = 0
        while(i < this.handTelCnt)
        {
          let kakaoAlimData =
          {
            clientName: uNickName,
            membership: membership,
            memPayDate: payDate,
            memPayAmt: mPayAmt,
            memExpDate: expDate,
            resCode: "",
            alimFlag: param,
            clientCall: this.handTel[i].aimCall,
          };

          let promise = this.$api("api/kakaoAlimSend8", {
            param: [{ kakaoAlimData: kakaoAlimData}]
          })

          promises.push(promise)
          i++
        }

        Promise.all(promises).then((results) => {
          console.log(results)
          this.$swal.fire('', '멤버십가입 알림톡이 발송되었습니다', 'success').then(() => {
            location.reload(true)
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
        })
      }
    },

    //회원탈퇴
    memWithdrawal(uEmail)
    {
      this.$swal.fire({
        html: '회원정보를 삭제합니까?<br>삭제 이후 복구는 되지 않습니다.<br>포인트와 멤버십정보도 모두 삭제되므로<br>고객께 이점을 꼭 안내하여 주십시오.',
        showCancelButton: true,
        confirmButtonText: '삭제',
        cancelButtonText: '취소',
        icon: 'info'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let del_memberInfo = await this.$api("/api/proc_memberDelete", {param: [uEmail]});
          if(del_memberInfo.affectedRows > 0)
          {
            this.$swal.fire('', '탈퇴완료', 'success')
            location.reload();
          }
          else
          {
            this.$swal.fire('', '오류가 발생했습니다('+ del_memberInfo.error.sqlMessage +')', 'warning')
            return false;
          }
        }
      })
    },
    //회원등록
    async registMember() {
      if(!this.uEmail)
      {
        this.$refs.uEmail.focus();
        return this.$swal.fire("","등록아이디를 입력하세요.","warning");
      }
      if(!this.uNickName)
      {
        this.$refs.uNickName.focus();
        return this.$swal.fire("","회원성명을 입력하세요.","warning");
      }
      if(!this.uPhone)
      {
        this.$refs.uPhone.focus();
        return this.$swal.fire("","기본연락처를 입력하세요.","warning");
      }
      if(!this.alimCallC)
      {
        this.$refs.alimCallC.focus();
        return this.$swal.fire("","카카오알림을 받을 연락처를 입력하세요.","warning");
      }
      if(!this.uBirthyear)
      {
        this.$refs.uBirthyear.focus();
        return this.$swal.fire("","생년(예:2002)을 입력하세요","warning");
      }
      if(!this.uBirthday)
      {
        this.$refs.uBirthday.focus();
        return this.$swal.fire("","생일(예:0120)을 입력하세요","warning");
      }
      if(!this.uGender)
      {
        this.$refs.uGender.focus();
        return this.$swal.fire("","성별을 선택하세요.","warning");
      }

      let insId = this.user.handlerId;
      let joinFlag = "H"

      let characters = '0123456789';
      let length = 5;
      let randomString = ''
      for (var i = 0; i < length; i++) {
        var randomIndex = Math.floor(Math.random() * characters.length);
        randomString += characters[randomIndex];
      }

      let pass = randomString

      let ins_memberInfo = await this.$api("/api/ins_memberInfo", {param: [
        this.uEmail, this.uNickName, joinFlag, this.uPhone, this.alimCallC, this.uBirthday, this.uGender, this.spRemarks, insId, pass, this.uBirthyear
      ]});
      if(Object.keys(ins_memberInfo)[0] === 'error') {
        this.$swal.fire('','등록실패(코드:ins_memberInfo)', 'error')
      }
      else {
        this.$swal.fire('','회원정보를 생성했습니다', 'success');
        location.reload();
      }
    },
    //포인트 내역화면
    goToPoint(uEmail){
      this.$router.push({path: '/pointList_admin', query: {id: uEmail}});
    },

    showRegistMember() {
      this.createFlag = (this.createFlag === "Y") ? "N" : "Y";
      this.uEmail = ""
      this.uNickName = ""
      this.uPhone = ""
      this.alimCallC = ""
      this.uBirthyear = ""
      this.uBirthday = ""
      this.uGender = ""
      this.spRemarks = ""
    },

    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
  }
}
</script>

<style scoped>
 /* input의 폭을 td에 맞춤 */
input {
  width: 100%;
  box-sizing: border-box;
}

/* 표 가독성: 여백/글자크기만 살짝 키움 (색상·구조는 기존 그대로) */
.member-table th,
.member-table td {
  padding: 8px 8px;
  font-size: 0.85rem;
  vertical-align: middle;
}
.member-table thead th {
  font-size: 0.8rem;
  white-space: nowrap;
}

/* 헤더 고정: 스크롤해도 컬럼명이 안 사라지도록 (시각적 변화 없음) */
.member-table-wrap {
  max-height: 75vh;
  overflow-y: auto;
}
.member-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #f1f1f1;
}

/**************************************
  # 로딩 인디케이터
**************************************/
.loading-indicator {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255,255,255,0.95);
  border-radius: 10px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 16px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: bold;
  color: #007bff;
}
.spinner {
  width: 28px;
  height: 28px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  margin-right: 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>